import { render, staticRenderFns } from "./docenteCreaProyecto.vue?vue&type=template&id=0e243fc2"
import script from "./docenteCreaProyecto.vue?vue&type=script&lang=js"
export * from "./docenteCreaProyecto.vue?vue&type=script&lang=js"
import style0 from "./docenteCreaProyecto.vue?vue&type=style&index=0&id=0e243fc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports